import React from 'react';
import { View } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import { FormattedMessage } from '@dbk/format';
import { VOP_VALIDATE_CODES } from '../constant';
import { SuccessDarkIcon, WarningDarkIcon, AttentionDarkIcon, QuestionDarkIcon } from '../../../components/common/icons';

const Helptext = ({verCode, messages}) => {
  let icon, helptext, type;
  switch(verCode){
    case VOP_VALIDATE_CODES.FULL_MATCH: {
      icon = <SuccessDarkIcon/>;
      helptext = "app.payments.vop.helptext.fullMatch";
      type = 'success';
    }
    break;
    case VOP_VALIDATE_CODES.CLOSED_MATCH: {
      icon = <WarningDarkIcon/>;
      helptext = "app.payments.vop.helptext.closedMatch";
      type = 'warning';
    }
    break;
    case VOP_VALIDATE_CODES.NO_MATCH: {
      icon = <AttentionDarkIcon/>;
      helptext = "app.payments.vop.helptext.noMatch";
      type = 'error';
    }
    break;
    case VOP_VALIDATE_CODES.VER_FAILED: {
      icon = <QuestionDarkIcon/>;
      helptext = "app.payments.vop.helptext.verFailed";
      type = 'warning';
    }
   break;
    default: {
      icon = <QuestionDarkIcon/>;
      helptext = "app.payments.vop.helptext.verFailed";
      type = 'warning';
    }
  }

  return(
    <View className="helptext">
      {icon}
      <View className="helptext__text">
        <FormattedMessage
          id={helptext}
          values={{ Exact_Name: <Text secondary className='helptext__text--sub-text'>{messages["app.payments.vop.helptext.closedMatch.exactName"]}</Text> }}
        >
          {(text) => <Text type={type}>{text}</Text>}
        </FormattedMessage>
      </View>
    </View>
  );
}

export default React.memo(Helptext);